import {
  ChannelTypeEnum,
  MailConversationDataType,
  WechatConversationDataType,
  WecomConversationDataType,
  WhatsAppConversationDataType,
} from "../types";
import { GLOBAL_ADDRESS } from "../constants";
import { WebSocketClient } from "./ws";
import chatSdkHooks from "../hooks";

export * from "./wecom-ws-client";
export * from "./wechat-ws-client";
export * from "./mail-ws-client";
export * from "./whatsapp-ws-client";
export * from "./ws";
export const globalChannelMessageWsClient = new WebSocketClient({
  wsAddress: GLOBAL_ADDRESS,
  onConnectStatusChange: () => void 0,
  onMessage: (data) => {
    const channelType = data?.channel_type as ChannelTypeEnum;
    const conversation = data?.data as
      | WechatConversationDataType
      | WecomConversationDataType
      | MailConversationDataType
      | WhatsAppConversationDataType;
    if (conversation) {
      chatSdkHooks.common.globalChannelMessageHook.emit({
        channelType,
        conversation,
      });
    }
  },
  onError: (data) => chatSdkHooks.common.wsErrorHook.emit(data),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});
